import React, { useState } from 'react'
import { Alert, Box, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, Stack, Typography } from '@mui/material'
import { SETTINGS } from '../constants/settings'
import { useSettings } from '../settings/SettingsContext'
import { apiErrorText } from '../service/coaching'

// Your own settings, kept with your account and used everywhere in the app.
export default function Settings () {
  const { settings, loaded, updateSetting } = useSettings()
  const [status, setStatus] = useState(null)

  const change = async (key, value) => {
    setStatus({ severity: 'info', text: 'Saving…' })
    try {
      await updateSetting(key, value)
      setStatus({ severity: 'success', text: 'Saved. This applies wherever you use Highlights.' })
    } catch (err) {
      setStatus({ severity: 'error', text: apiErrorText(err, 'Your change couldn’t be saved. Try again.') })
    }
  }

  return (
    <Box sx={{ maxWidth: 820, mx: 'auto', py: 2 }}>
      <Stack spacing={2.5}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>Settings</Typography>
          <Typography variant="body1" color="text.secondary">Saved with your account, so they apply on every device.</Typography>
        </Box>

        <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 } }}>
          <Typography variant="overline" color="primary.light" sx={{ letterSpacing: '.14em' }}>Watching and clipping</Typography>
          {Object.entries(SETTINGS).map(([key, spec]) => (
            <FormControl key={key} component="fieldset" sx={{ mt: 1.5, display: 'block' }} disabled={!loaded}>
              <FormLabel component="legend" sx={{ fontWeight: 700, color: 'text.primary' }}>{spec.label}</FormLabel>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{spec.help}</Typography>
              <RadioGroup name={key} value={settings[key]} onChange={event => change(key, event.target.value)}>
                {spec.options.map(option => (
                  <FormControlLabel key={option.value} value={option.value} control={<Radio />} sx={{ alignItems: 'flex-start', mb: 1 }}
                    label={<Box sx={{ pt: 0.75 }}>
                      <Typography variant="body1">
                        {option.label}{option.value === spec.default ? ' (default)' : ''}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">{option.description}</Typography>
                    </Box>} />
                ))}
              </RadioGroup>
            </FormControl>
          ))}
          {status && <Alert severity={status.severity} sx={{ mt: 1 }} role="status">{status.text}</Alert>}
        </Paper>
      </Stack>
    </Box>
  )
}
